import { SET_COURSE_VIEW_TEMPLATE, SET_CARD_COURSE_COUNT, SET_COURSE_INSTANCE_VIEW_TEMPLATE, SET_DELETE_COURSE_TEMPLATE, SET_SELECTED_CARD, SET_DELETE_COURSE_INSTANCE, GET_VM_LIST_BY_SITE_REQUEST, SET_VM_LIST_BY_SITE, RESET_DELETE_COURSE_TEMPLATE, RESET_DELETE_COURSE_INSTANCE_TEMPLATE } from "./view-course-template.action";

const initalState = {
  viewCourseViewData: [],
  viewCourseInstanceData: { CourseInstanceData: [] },
  cardCourseCountData: [],
  deleteCourseTemplateData: null,
  selectedCard: 2,
  vmListBySite: [],
  deleteCourseInstanceData: null
};

export const viewCourseTemplateReducer = (state = initalState, action: any) => {
  switch (action.type) {
    case SET_COURSE_VIEW_TEMPLATE:
      return {
        ...state,
        viewCourseViewData: action.payload,
      };
    case SET_CARD_COURSE_COUNT:
      return {
        ...state,
        cardCourseCountData: action.payload,
      };
      case SET_COURSE_INSTANCE_VIEW_TEMPLATE:
      return {
        ...state,
        viewCourseInstanceData: action.payload,
      };
       case SET_DELETE_COURSE_TEMPLATE:
      return {
        ...state,
        deleteCourseTemplateData: action.payload,
      };
       case RESET_DELETE_COURSE_TEMPLATE:
      return {
        ...state,
        deleteCourseTemplateData: null,
      };
       case SET_SELECTED_CARD:
      return {
        ...state,
        selectedCard: action.payload,
      };
    case SET_DELETE_COURSE_INSTANCE:
      return {
        ...state,
        deleteCourseInstanceData: action.payload,
      };
      case RESET_DELETE_COURSE_INSTANCE_TEMPLATE:
      return {
        ...state,
        deleteCourseInstanceData: null,
      };
    case GET_VM_LIST_BY_SITE_REQUEST:
      return {
        ...state,
      };
    case SET_VM_LIST_BY_SITE:
      return {
        ...state,
        vmListBySite: action.payload,
      };
    default:
      return state;
  }
};
